<template>
  <!-- Modal terms -->
  <div
    id="coworking-modal"
    aria-hidden="true"
    aria-labelledby="coworkingLabel"
    class="modal fade"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 id="coworkingLabel" class="modal-title">Yasal Adres Hizmeti</h4>
          <button aria-hidden="true" class="close" data-dismiss="modal" type="button">&times;</button>
        </div>
        <div class="modal-body modal-body-min">
          <p>
            Dilerseniz aylık aboneliğinize ilave ücret ödeyerek yasal adres hizmetini kullanabilir, faaliyet adresi
            olarak gösterebilirsiniz.
          </p>
          <h5>Yasal Adres Hizmetinin Avantajları Nelerdir?</h5>
          <ul style="list-style-type: circle; margin-left: 20px">
            <li>Şirket açılışı dışında Yasal Adrese uğramanıza gerek olmadan resmi adres olarak gösterirsiniz.</li>
            <li>Kargo veya posta karşılama hizmetini ücretsiz kullanırsınız.</li>
            <li>Kesilen faturayı gider olarak gösterirsiniz.</li>
            <li>
              Stopaj ödemezsiniz. (Yasal Adres dışındaki faturasız kira sözleşmelerinde %20 stopaj ödemeniz gerekir)
            </li>
            <li>Sektörün en iyi paylaşımlı ofisinde en uygun fiyat garantisi alırsınız.</li>
          </ul>
          <img class="full-width" src="/img/coworking.jpg" />
        </div>
        <div class="modal-footer">
          <button class="btn_1" data-dismiss="modal" type="button">Kapat</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>
<script>
export default {
  name: 'CoworkingModal',
};
</script>
